<template>
  <div class="section-title page-title">
    <h2 class="title h2-caslon text-white text-center f-44">{{ title }}</h2>
    <p v-if="description" class="description text-white">{{ description }}</p>
  </div>
</template>

<script setup>
const props = defineProps([
  'title',
  'description',
  'titleSize'
])
</script>

<style scoped>
.page-title {
  padding: 100px 0 95px 0;
}

.page-title .title {
  font-weight: 600;
  margin-bottom: 0;
}

.page-title .description {
  font-size: 17px;
  font-family: 'Myriad-Pro', sans-serif;
  line-height: 1.8;
  text-align: center;
  letter-spacing: -.2px;

  padding-left: 10px;
  padding-right: 10px;
  margin-top: 30px;
  margin-bottom: 0;
}
</style>